var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "list-settings-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.051,
    height: 18.051,
    viewBox: "0 0 21.051 21.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-none",
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M0,0H21.051V21.051H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M2,16.28H8.14v1.754H2Zm0-6.14H9.894v1.754H2ZM2,4H19.543V5.754H2Zm16.38,7.916,1.014-.343.877,1.519-.8.706a3.524,3.524,0,0,1,0,1.454l.8.706-.877,1.519-1.014-.343a3.5,3.5,0,0,1-1.259.728l-.21,1.048H15.157l-.211-1.049a3.505,3.505,0,0,1-1.258-.728l-1.014.344L11.8,15.959l.8-.706a3.524,3.524,0,0,1,0-1.454l-.8-.706.877-1.519,1.014.343a3.5,3.5,0,0,1,1.259-.728l.21-1.048h1.754l.211,1.049a3.487,3.487,0,0,1,1.258.728ZM16.034,16.28a1.754,1.754,0,1,0-1.754-1.754A1.754,1.754,0,0,0,16.034,16.28Z",
    transform: "translate(-0.246 -0.491)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/Configuration.2ae02e6c3b48c558300a43332be92970.svg";
export { ForwardRef as ReactComponent };